<template>
	<!-- <v-empty-state
		headline="Welcome,"
		title="What would you like to do today?"
	> -->
	<v-empty-state
		
		title="Швидке оформлення документів онлайн 24/7"
	>
	<!-- headline="Вітаємо!" -->
		<!-- <template v-slot:headline>
			<div class="text-headline-small font-weight-bold">Вітаємо!</div>
		</template> -->
	<!-- :icon="system.icon" -->
		<v-container>
			<!-- <v-row>
				<v-col cols="12" :md="menu.length < 3 ? 0 : 6" v-for="(item, index) in menu" :key="index">
					<v-card
						:text="item.description"
						:title="item.name"
						:to="{ name: item.code }"
					>
						<template v-slot:prepend>
							<v-icon :icon="item.icon" :color="item.color"></v-icon>
						</template>
					</v-card>
				</v-col>
			</v-row> -->
		</v-container>

		<template v-slot:text>
			<div class="text-medium-emphasis text-caption">
				<!-- Great job on completing all your tasks! This might be a good time to relax or consider planning your next set of goals. If you think of something new, just hit the button below to add a new task. -->
			</div>
		</template>

		<v-row align="center" class="fill-height text-center" justify="center">
			<template v-for="(item, i) in items" :key="i">
				<!-- <v-col cols="12" md="3"> -->
				<v-col cols="12">
					<v-hover v-slot="{ isHovering, props }">
						<v-card
							:class="{ 'on-hover': isHovering }"
							:elevation="isHovering ? 4 : 2"
							v-bind="props"
							min-width="300"
							min-height="250"
							@click="onCard(item.code)"
						>
							<v-img
								height="100px"
								:src="item.image"
								aspect-ratio="16/9"
								class="mt-6"
							>
								<!-- <v-expand-transition>
									<p v-if="isHovering"
										class="d-flex bg-secondary v-card--reveal text-h6 text-center"
										style="height: 100%;"
									>
										<p v-for="(vid, v) in item.vids" :key="v">{{ vid.name }}</p>
										<v-list dark>
											<v-list-item v-for="(vid, index) in item.vids" :key="index" :value="index">
												<v-list-item-title>{{ vid.name }}</v-list-item-title>
											</v-list-item>
										</v-list>
									</p>
								</v-expand-transition> -->
							</v-img>

							<!-- <p class="my-6 text-overline">{{ item.title }}</p> -->
							<p class="mt-6 text-overline">{{ item.title }}</p>
							<p class="text-caption">{{ item.subtitle }}</p>
						</v-card>
					</v-hover>
				</v-col>
			</template>
		</v-row>
	</v-empty-state>
</template>


<script>
export default {
	name: 'Home',
	components: {
		//HelloWorld
	},
	data: () => ({
		view: {},
		views: [
			{ code: 'var1', 	icon: 'mdi-home-floor-1' },
			{ code: 'var2', 	icon: 'mdi-home-floor-2' },
			{ code: 'var3', 	icon: 'mdi-home-floor-3' },
		],

		items: [
			//{ title: 'Надання документів для врегулювання збитку', subtitle: 'Фото з місця події, застрахованого об''єкту, документів' та документи', text: 'Фотографування або завантаження документів: Фото з місця події, Свідоцтво про реєстрацію автомобіля, Посвідчення водія, Паспорт та ІПН власника автомобіля (тільки для фізичних осіб), Європротокол або документи поліції (за наявності), Фото пошкодженого автомобіля, Реквізити для отримання відшкодування та e-mail власника автомобіля.' },
			{ 
				code: 'auto',
				title: 'ОСЦПВ',
				subtitle: 'Подати документи',
				text: 'Не має необхідності витрачати час на особистий візит до страхової компанії. За допомогою даного сервісу Ви зможете надати необхідні для оформлення страхового випадку документи, фотографії та дані в режимі онлайн. В тому числі і банківські реквізити для отримання страхового відшкодування.',
				icon: 'mdi-car',
				//image: require('@/assets/home/car_exident.jpg'),
				image: 'https://grdn.com.ua/img/content/category/1.svg',
				//to: { name: 'ClaimApplication', params: { direction: 'auto' } },
				to: { name: 'ClaimApplication', state: { direction: 'auto' } },
				vids: [
					{ name: 'Автоцивілка' },
					{ name: 'КАСКО' },
					{ name: 'Зелена картка' },
				]
			},
			/* { 
				code: 'health',
				title: "Здоров'я",
				subtitle: '',
				text: '',
				icon: 'mdi-car',
				//image: require('@/assets/home/car_exident.jpg'),
				image: 'https://grdn.com.ua/img/content/category/2.svg',
				//to: { name: 'ClaimApplication', params: { direction: 'health' }},
				to: { name: 'ClaimApplication', state: { direction: 'health' }},
				vids: [
					{ name: 'Медицина в дорозі' },
					{ name: 'Нещасний випадок' },
				]
			},
			{ 
				code: 'tourism',
				title: 'Туризм',
				subtitle: '',
				text: '',
				icon: 'mdi-car',
				//image: require('@/assets/home/car_exident.jpg'),
				image: 'https://grdn.com.ua/img/content/category/3.svg',
				//to: { name: 'ClaimApplication', params: { direction: 'tourism' }},
				to: { name: 'ClaimApplication', state: { direction: 'tourism' }},
				vids: [
					{ name: 'Туристичне страхування' },
				]
			},
			{ 
				code: 'property',
				title: 'Майно',
				subtitle: '',
				text: '',
				icon: 'mdi-car',
				//image: require('@/assets/home/car_exident.jpg'),
				image: 'https://grdn.com.ua/img/content/category/4.svg',
				//to: { name: 'ClaimApplication', params: { direction: 'property' }},
				to: { name: 'ClaimApplication', state: { direction: 'property' }},
				vids: [
					{ name: 'Страхування майна' },
				]
			}, */
		],
	}),

	methods: {
		onCard(direction) {
			//console.log(this.$options.name,  'onCard', 'direction', direction) 

			this.$router.push({ 
				name: 'Claim',
				state: { direction: direction },
				//query: { direction: direction }
			}).catch(err => {});
		}
	},
}
</script>
